import { SHOW_DEMO_SESSIONS } from './demoSessions.action';

export interface DemoSessionsState {
    showDemoSessions: boolean;
    storeGuid: string;
}

export default (
    state: DemoSessionsState = {
        showDemoSessions: false,
        storeGuid: '',
    },
    action: any,
): DemoSessionsState => {
    switch (action.type) {
        case SHOW_DEMO_SESSIONS:
            return {
                ...state,
                showDemoSessions: action.payload,
                storeGuid: action.storeGuid ? action.storeGuid : state.storeGuid,
            };

        default:
            return state;
    }
};
